import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { CartsQuery } from 'projects/cart-tv/src/app/data/carts.query';
import { environment } from 'projects/cart-tv/src/environments/environment';
import { defer, fromEvent, Observable, Subject, Subscription, timer } from 'rxjs';
import { Cart } from '../../data/cart';
import { Tray } from 'projects/cart-tv/src/app/data/tray';
import { CartsStore } from '../../data/carts.store';
import { arrayUpdate } from '@datorama/akita';
import { CabinetsService } from 'projects/app-misc/src/app/modules/cabinets/data/cabinets.service';
import { Cabinet } from 'projects/app-misc/src/app/modules/cabinets/data/cabinet';
import { MatDialog } from '@angular/material/dialog';
import { CartCabinetEditDialogComponent } from '../cart-cabinet-edit-dialog/cart-cabinet-edit-dialog.component';
import { CartScan } from '../../data/cart-scan';
import { bufferCount, filter, startWith, switchMap, take, takeUntil, timeoutWith } from 'rxjs/operators';
import { CartsService } from 'projects/cart-tv/src/app/data/cart.sevice';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import {
  CartProjectEditDialogComponent
} from 'projects/cart-tv/src/app/carts-main-view/cart-project-edit-dialog/cart-project-edit-dialog.component';

class ItemSection {
  trayNumber: string;
  classes: string[]
}

class CartSection {
  traySections: ItemSection[]
  classes: string[]
}

class VisualCart {
  sections: CartSection[]
}

class TrayObj {
  tray: Tray;
  cabinetsString: string;
  cabinetsSet: Set<number>;
}


@Component({
  selector: 'app-cart-view',
  templateUrl: './cart-view.component.html',
  styleUrls: ['./cart-view.component.scss']
})
@RxJSUnsubscribe
export class CartViewComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  @Input()
  cart: Cart;

  @Input()
  fromAssembyView: boolean;

  traysMap = new Map<string, TrayObj>()

  prevElem: HTMLElement;

  cartTimer: Subscription;

  visualCart: VisualCart = new VisualCart()

  allCabs: Cabinet[] = [];

  lastScannedString = '';

  constructor(
    protected dialog: MatDialog,
    private cartsQuery: CartsQuery,
    private cartsStore: CartsStore,
    private cartsService: CartsService,
    private cabinetsService: CabinetsService,
    private el: ElementRef
  ) {
  }

  ngOnInit(): void {
    this.fillCartData();
    this.fillCart();
    this.getCabinets();

    this.cartsQuery.lastScan$
    .pipe(
      filter(tray => tray && tray.cartId === this.cart.id)
    ).subscribe(tray => {
      if(!tray) return

      this.highlightSection(tray)
    })

    if(this.fromAssembyView) {
      this.cartsService.subToScanner()
    }
  }


  getCabinets() {
    if(this.cart.project) {
      this.cabinetsService.getCabinets(this.cart.project.id).subscribe(cabs => {
        this.allCabs = cabs
      })
    } else {
      this.allCabs = []
    }
  }


  highlightSection(tray: Tray) {
    const cartId = tray.cartId
    const sectionId = tray.id
    const sectionStrId = tray.number.toLowerCase() + '-section'

    if(this.prevElem) {
      this.prevElem.classList.remove('HIGHLIGHT-SECTION')
    }

    if(this.cartTimer) {
      this.cartTimer.unsubscribe();
      this.cartTimer = null;
    }

    if(cartId === this.cart.id) {
      const currElem = this.el.nativeElement.getElementsByClassName(sectionStrId)[0] as HTMLElement

      this.fillNSortTray(tray)

      if(tray.filledQty !== this.traysMap.get(tray.number).tray.filledQty) {
        this.changeTrayNum(tray)
      }

      if(currElem) {
        let timerTime = 0;

        if(currElem === this.prevElem) {
          currElem.classList.remove('HIGHLIGHT-SECTION')
          timerTime = environment.defaultCartGreenReShowTime
          this.lastScannedString = ''
        }

        timer(timerTime).subscribe(emit => {
          currElem.classList.add('HIGHLIGHT-SECTION')
          this.lastScannedString = tray.partLabel ? tray.partLabel.partName : ''

          this.prevElem = currElem

          this.cartTimer = timer(environment.defaultCartGreenStyleDissapearTime).subscribe((emit => {
            this.lastScannedString = ''
            currElem.classList.remove('HIGHLIGHT-SECTION')
            // this.lastScannedString = ''
            this.prevElem = null;
          }))
        })

        // this.prevElem = currElem
        //
        // this.cartTimer = timer(environment.defaultCartGreenStyleDissapearTime).subscribe((emit => {
        //   currElem.classList.remove('HIGHLIGHT-SECTION')
        //   this.prevElem = null;
        // }))
      }
    }
  }

  changeTrayNum(tray: Tray) {
    // this.cartsStore.update(this.cart.id, ({trays}) => ({
    //   trays: arrayUpdate(trays, tray.id, {filledQty: tray.filledQty} as Tray)
    // }))

    // this.traysMap.get(tray.number).totalQty = tray.totalQty
    // this.traysMap.get(tray.number).filledQty = tray.filledQty
  }

  fillCartData() {
    this.cart.trays.forEach(tray => {
      this.fillNSortTray(tray)
    })
  }


  fillNSortTray(tray: Tray) {
    tray.cabinets.sort((cabA, cabB) => cabA.cabinetId - cabB.cabinetId)

    const cabinetsSet = new Set<number>()
    tray.cabinets.forEach(cab => {
      cabinetsSet.add(cab.cabinetId)
    })
    let cabinetsString = ''
    cabinetsSet.forEach(cabId => {
      cabinetsString += '#' + cabId + ' '
    })

    this.traysMap.set(tray.number, {
      cabinetsSet,
      cabinetsString,
      tray
    })
  }

  changeCab(trayNumber: string) {
    const selection = window.getSelection();
    if(selection.type === 'Range') {
      return
    }

    const dialogRef = this.dialog.open(CartCabinetEditDialogComponent, {
      data: {
        allCabs: this.allCabs,
        cartId: this.cart.id,
        trayId: this.traysMap.get(trayNumber).tray.id,
        trayNumber,
        selectedIdsSet: this.traysMap.get(trayNumber).cabinetsSet
      },
      panelClass: 'change-cab-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
        const tray = result as Tray

        if(tray && tray.id) {
          this.fillNSortTray(tray)
        }
      }
    )
  }

  changeProject() {
    const selection = window.getSelection();
    if(selection.type === 'Range') {
      return
    }

    const dialogRef = this.dialog.open(CartProjectEditDialogComponent, {
      data: {
        projs: this.cartsStore.allProjects,
        cartId: this.cart.id,
        selectedId: this.cart.project ? this.cart.project.id : null
      },
      panelClass: 'change-cab-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(res => {
        const cart = res as Cart

        if(cart && cart.id) {
          this.cart.project = cart.project
          this.getCabinets()

          cart.trays.forEach(tray => {
            this.fillNSortTray(tray)
          })

          this.lastScannedString = ''
        }

        if(res && res === 'DELETE') {
          this.cartsStore.deleteCart(this.cart.id)
        }
      }
    )
  }

  ngOnDestroy() {
    this.cartsService.unSubFromScanner()
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

  fillCart() {
    this.visualCart = {
      sections: [{
        classes: ['long-section', 'long-left-section'],
        traySections: [{
          classes: ['l1-section'],
          trayNumber: 'L1'
        }]
      }, {
        classes: ['left-section'],
        traySections: [{
          classes: ['s1-section'],
          trayNumber: 'S1'
        }, {
          classes: ['s4-section', 'down-section'],
          trayNumber: 'S4'
        }]
      }, {
        classes: ['left-section'],
        traySections: [{
          classes: ['s2-section'],
          trayNumber: 'S2'
        }, {
          classes: ['s5-section', 'down-section'],
          trayNumber: 'S5'
        }]
      }, {
        classes: ['right-section'],
        traySections: [{
          classes: ['s3-section'],
          trayNumber: 'S3'
        }, {
          classes: ['s6-section', 'down-section'],
          trayNumber: 'S6'
        }]
      }, {
        classes: ['long-section', 'long-right-section'],
        traySections: [{
          classes: ['l2-section'],
          trayNumber: 'L2'
        }]
      }]
    }
  }

}
